import { getGrpcPromise } from '@monorepo/grpc';
import { OfferService } from '@spilca/order_ts/v1/order_web/offer_web_pb_service';
import offerFilterConstructor from '@monorepo/offers/utils/offerFilterConstructor';
import { ListOfferPaymentConditionRequest } from '@spilca/order_ts/v1/order/model_offer_pb';

const getPaymentConditionsRequest = (d: any) => {
  const getPaymentConditions = getGrpcPromise(
    OfferService.ListOfferPaymentCondition
  );
  const [, params] = d.queryKey;
  const offerFilter = offerFilterConstructor(params, d.active);
  const request = new ListOfferPaymentConditionRequest();
  request.setFilter(offerFilter);
  return getPaymentConditions(request);
};

export default getPaymentConditionsRequest;
